// Sticky add-to-cart bar (CRO playbook 3.3 / 8.2) - phones and desktop.
//
// Built in JS on purpose: it duplicates a control that already exists in the markup, so
// rendering it server-side would put a second "Adauga in cos" in the page for screen
// readers and for Google. As an enhancement, the page is unchanged with JS off.
//
// The bar never submits anything itself - it calls requestSubmit() on the real form, so
// the existing AJAX handler runs, the drawer opens and the counters update as usual.
//
// Visibility uses IntersectionObserver against the viewport, which is right on both
// layouts: on phones the document scrolls, and from 990px up Horizon locks html/body
// and scrolls .page-wrapper instead - the viewport observer does not care which.
(function () {
  if (!('IntersectionObserver' in window)) return;

  var form = document.querySelector('.mdc-buy');
  if (!form) return;
  var realBtn = form.querySelector('button[type="submit"]');
  if (!realBtn) return;

  var priceEl = document.querySelector('.mdc-product__price');
  var titleEl = document.querySelector('h1');
  // The h1 is the range name ("Microdacyn Wound Care"); the size lives in the size
  // switcher. The bar needs both - four sizes share one name.
  var sizeEl = document.querySelector('.mdc-sizes [aria-current="true"]');
  var drawer = document.getElementById('cart-drawer');
  var footer = document.querySelector('footer');
  var ogImage = document.querySelector('meta[property="og:image:secure_url"], meta[property="og:image"]');

  var bar = document.createElement('div');
  bar.className = 'mdc-stickybuy';
  bar.innerHTML =
    '<div class="mdc-stickybuy__inner">' +
    '<img class="mdc-stickybuy__img" alt="" width="52" height="52" loading="lazy">' +
    '<span class="mdc-stickybuy__text">' +
    '<span class="mdc-stickybuy__title"></span>' +
    '<span class="mdc-stickybuy__price"></span>' +
    '</span>' +
    '<button type="button" class="mdc-stickybuy__btn"></button>' +
    '</div>';

  var barImg = bar.querySelector('.mdc-stickybuy__img');
  var barTitle = bar.querySelector('.mdc-stickybuy__title');
  var barPrice = bar.querySelector('.mdc-stickybuy__price');
  var barBtn = bar.querySelector('.mdc-stickybuy__btn');

  // The thumbnail only shows on desktop. Shopify's og:image is the product's featured
  // image; asking the CDN for 104px keeps it to a few KB.
  if (ogImage && ogImage.content) {
    var src = ogImage.content.replace(/^http:/, 'https:');
    barImg.src = src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=104';
  } else {
    barImg.remove();
  }

  function titleText() {
    var title = titleEl ? titleEl.textContent.trim() : '';
    var size = sizeEl ? sizeEl.textContent.trim() : '';
    if (size && title.toLowerCase().indexOf(size.toLowerCase()) === -1) return title + ' · ' + size;
    return title;
  }

  // The price element holds the current price and, on discounted products, the struck
  // old price in a nested <s>. The bar only wants the current one.
  function currentPrice() {
    if (!priceEl) return '';
    var clone = priceEl.cloneNode(true);
    clone.querySelectorAll('s').forEach(function (s) { s.remove(); });
    return clone.textContent.trim();
  }

  function sync() {
    barTitle.textContent = titleText();
    barPrice.textContent = currentPrice();
    barBtn.textContent = (realBtn.textContent || '').trim();
    barBtn.disabled = realBtn.disabled;
  }

  sync();
  document.body.appendChild(bar);

  barBtn.addEventListener('click', function () {
    if (barBtn.disabled) return;
    if (typeof form.requestSubmit === 'function') form.requestSubmit(realBtn);
    else realBtn.click();
  });

  // Show the bar once the real button has scrolled away. Hide it while the cart drawer
  // is open (the drawer sits in the top layer; the bar would peek out underneath) and
  // while the footer is on screen, so it never covers the legal links and ANPC badges.
  var buttonVisible = true;
  var footerVisible = false;

  function drawerOpen() {
    return drawer ? !!drawer.querySelector('dialog[open]') : false;
  }

  function update() {
    bar.classList.toggle('is-on', !buttonVisible && !footerVisible && !drawerOpen());
  }

  new IntersectionObserver(
    function (entries) {
      buttonVisible = entries[0].isIntersecting;
      update();
    },
    { rootMargin: '0px 0px -10px 0px', threshold: 0 }
  ).observe(realBtn);

  if (footer) {
    new IntersectionObserver(
      function (entries) {
        footerVisible = entries[0].isIntersecting;
        update();
      },
      { threshold: 0 }
    ).observe(footer);
  }

  if (priceEl) new MutationObserver(sync).observe(priceEl, { childList: true, subtree: true, characterData: true });
  new MutationObserver(sync).observe(realBtn, { attributes: true, childList: true, subtree: true });

  if (drawer) {
    new MutationObserver(update).observe(drawer, { attributes: true, subtree: true, attributeFilter: ['open'] });
  }
})();
